<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div class="modal suggested-address-modal">
            <div class="modal__header">
                <h2 class="headline-s">Delete Customer Address?</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="actions">
                <RothcoCta class="primary" id="submitButton" @click="submit()">Yes</RothcoCta>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>

    import { computed, inject } from "vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import CloseIcon from "@icons/closeIcon.svg";
    const dialogRef = inject('dialogRef');

    const closeDialog = () => {
        dialogRef?.value?.close();
    }

    const customerAddressId = computed(()=>{
        return dialogRef.value?.data?.customer_address_id;
    })

    const submit = ()=>{
        dialogRef?.value?.data?.deleteCustomerAddress(customerAddressId.value);
        closeDialog();
    }

</script>
